// CardSkeleton Component - Pure MUI
import { Box, Card, CardContent, Skeleton } from '@mui/material';

export const CardSkeleton = () => {
  return (
    <Card sx={{ borderRadius: 3, overflow: 'hidden' }}>
      <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {/* Header */}
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
          <Skeleton variant="rounded" width={40} height={40} />
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            <Skeleton variant="rounded" width={60} height={24} sx={{ borderRadius: 2 }} />
            <Skeleton variant="rounded" width={80} height={24} sx={{ borderRadius: 2 }} />
          </Box>
        </Box>

        {/* Title */}
        <Skeleton variant="text" width="90%" height={24} />
        <Skeleton variant="text" width="60%" height={24} />

        {/* Outcomes */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Skeleton variant="rounded" height={48} sx={{ borderRadius: 2 }} />
          <Skeleton variant="rounded" height={48} sx={{ borderRadius: 2 }} />
        </Box>

        {/* Footer */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            pt: 1.5,
            borderTop: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Skeleton variant="text" width={120} height={20} />
          <Skeleton variant="rounded" width={32} height={32} sx={{ ml: 'auto', borderRadius: 1 }} />
        </Box>
      </CardContent>
    </Card>
  );
};

export default CardSkeleton;
